module.exports = require("react-images");